import type { SVGProps } from "react";

export function Spark(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      fill="currentColor"
      {...props}
    >
      <rect
        x="777.24"
        y="638.25"
        width="193.77"
        height="335.91"
        transform="translate(-301.6 984.37) rotate(-51.3)"
      />
      <polygon points="837.58 897.31 685.06 777.79 1134.38 204.37 1134.33 214.06 837.58 897.31" />
      <polygon points="618.32 1406.37 611.47 1408.51 915.12 713.43 1067.64 832.95 618.32 1406.37" />
      <rect
        x="1134.43"
        y="669.22"
        width="127.27"
        height="220.64"
        transform="translate(-229.48 851.27) rotate(-35.93)"
      />
      <polygon points="1159.06 830.87 1083.27 728.62 1467.7 443.71 1465.98 449.83 1159.06 830.87" />
      <polygon points="931.54 1115.09 926.83 1115.26 1240.18 727.92 1315.97 830.18 931.54 1115.09" />
      <rect x="680.71" y="1473.33" width="41.79" height="149" />
      <rect x="787.98" y="1473.33" width="41.79" height="112.96" />
      <rect
        x="557.76"
        y="1468.46"
        width="41.79"
        height="157.12"
        transform="translate(-990.51 1031.42) rotate(-51.3)"
      />
      <rect
        x="1263.98"
        y="1489.99"
        width="41.79"
        height="147.77"
        transform="translate(-735.92 1677.87) rotate(-53.82)"
      />
      <rect
        x="1255.18"
        y="1496.38"
        width="99.72"
        height="41.79"
        transform="translate(-627.53 997.26) rotate(-34.24)"
      />
      <rect x="503.95" y="1472.53" width="149" height="41.79" />
      <rect x="680.63" y="1472.53" width="149.42" height="41.79" />
      <rect x="680.77" y="1544.71" width="149" height="41.79" />
      <rect x="1032.77" y="1473.33" width="41.79" height="149" />
      <rect x="1139.98" y="1473.33" width="41.79" height="112.96" />
      <rect x="1032.77" y="1472.53" width="149" height="41.79" />
      <rect x="1032.77" y="1544.71" width="149" height="41.79" />
      <rect x="856.62" y="1473.33" width="41.79" height="149" />
      <rect x="1209.08" y="1473.33" width="41.79" height="149" />
      <rect x="963.83" y="1473.33" width="41.79" height="149" />
      <rect x="856.62" y="1472.53" width="149" height="41.79" />
      <rect x="856.62" y="1544.71" width="149" height="41.79" />
      <rect x="856.62" y="1648.59" width="41.79" height="149" />
      <rect x="963.83" y="1648.59" width="41.79" height="149" />
      <rect x="1084.59" y="1648.59" width="41.79" height="149" />
      <rect x="856.62" y="1647.78" width="149" height="41.79" />
      <rect x="856.62" y="1756.79" width="149" height="41.79" />
      <rect x="503.95" y="1580.27" width="149" height="41.79" />
      <rect
        x="557.76"
        y="1645.5"
        width="41.79"
        height="157.12"
        transform="translate(-1128.68 1097.78) rotate(-51.3)"
      />
      <rect x="503.95" y="1649.57" width="149" height="41.79" />
      <rect x="503.95" y="1757.31" width="149" height="41.79" />
      <rect
        x="1203.53"
        y="1703.17"
        width="157.12"
        height="41.79"
        transform="translate(-796.43 1180.09) rotate(-38.7)"
      />
      <rect x="1207.8" y="1649.57" width="149" height="41.79" />
      <rect x="1207.8" y="1757.31" width="149" height="41.79" />
      <rect x="680.71" y="1649.85" width="41.79" height="149" />
      <rect x="787.98" y="1649.85" width="41.79" height="112.96" />
      <rect x="680.77" y="1649.05" width="149" height="41.79" />
      <rect x="680.77" y="1721.23" width="149" height="41.79" />
      <polygon points="1183.17 1622.06 1129.78 1557.66 1097.6 1584.34 1128.88 1622.06 1183.17 1622.06" />
      <rect x="1032.77" y="1647.78" width="149" height="41.79" />
    </svg>
  );
}
